import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICommand } from '../telemetry/models/capability-model-data';
import { CommandSelectedEvent } from './command-selected-event';

@Component({
    selector: 'app-commands',
    templateUrl: './commands.component.html',
    styleUrls: ['./commands.component.scss'],
    standalone: false,
})
export class CommandsComponent implements OnInit {
    public isSetCommand: boolean;
    @Input() public commands: ICommand[];
    @Input() public isCommandExecuting: { [name: string]: boolean };
    @Input() public commandError: { [name: string]: string };
    @Input() public isSelectedAssetDisabled: boolean;
    @Output() public emitExecuteCommand = new EventEmitter<CommandSelectedEvent>();

    public ngOnInit() {
        this.isSetCommand = false;
    }

    public executeCommand(name: string, parameters: { [key: string]: string }) {
        const commandValue: CommandSelectedEvent = { name, parameters };
        this.emitExecuteCommand.emit(commandValue);
    }

    public onPropertyChanged(values: object) {
        if (Object.keys(values).length !== 0) {
            this.isSetCommand = true;
        } else {
            this.isSetCommand = false;
        }
    }
}
